var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: _vm.routeName, params: _vm.routeParams },"title":_vm.text.edit + ' ' + _vm.linkName}},[_vm._v(_vm._s(_vm.text.edit))])}
var staticRenderFns = []

export { render, staticRenderFns }